import React from 'react'
import { connect } from 'react-redux'
import { addForwardContact, formatPhone, removeForwardContact, resetAllForwards } from '../redux/FeedbackRedux'
import axios from 'axios'

class ForwardFeedback extends React.Component {
    constructor(props) {
        super(props);
        this.addToCurrentForwards = this.addToCurrentForwards.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleNickname = this.handleNickname.bind(this);
        this.handleAddToContactsCheckbox = this.handleAddToContactsCheckbox.bind(this);
        this.generateForwards = this.generateForwards.bind(this);
        this.removeFromForwards = this.removeFromForwards.bind(this);
        this.handleNewRecipients = this.handleNewRecipients.bind(this);
        this.toggleSelected = this.toggleSelected.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.handleEditField = this.handleEditField.bind(this);
        this.saveEditedContact = this.saveEditedContact.bind(this);
        this.addContactAndSort = this.addContactAndSort.bind(this);

        // AI Summary
        this.handleAiRecipientAdd = this.handleAiRecipientAdd.bind(this);
        this.handleDeleteAiRecipient = this.handleDeleteAiRecipient.bind(this);

        this.state = {
            email: '',
            recipient: '',
            all_forwards: [],
            nickname: '',
            selectedValues: [], // Store indices of selected items
            newlyAdded: [],
            idsEdited: [
                {
                    id: "",
                    nickname: "",
                    email: "",
                    phone: ""
                }
            ],
            sortedContacts: [],
            errorMessages: [
                {
                    id: "",
                    messages: []
                }
            ],
            aiSummaryRecipients: props.existingRecipients || []
        };
        this.contactsScrollListRef = React.createRef();
    }

    toggleSelected(value) {
        this.setState(prevState => {
            const isSelected = prevState.selectedValues.some(item => {
                return (item.email === value.email && item.email) || (item.recipient === value.recipient && item.recipient);
            });

            let newSelectedValues;

            if (!isSelected) {
                // Add the value to selectedValues if it's not already selected
                newSelectedValues = [...prevState.selectedValues, value];
            } else {
                // Remove the value from selectedValues if it's already selected
                newSelectedValues = prevState.selectedValues.filter(item => {
                    if ((item.email === value.email && item.email) && (!item.recipient || !value.recipient)) {
                        return false; // Remove the entry if email is being deselected and recipient is already null
                    } else if ((item.recipient === value.recipient && item.recipient) && (!item.email || !value.email)) {
                        return false; // Remove the entry if recipient is being deselected and email is already null
                    } else {
                        return true; // Keep the entry if neither email nor recipient is being deselected or both are still present
                    }
                });
            }

            return { selectedValues: newSelectedValues };
        });
    }

    // handle new contacts
    handleNewRecipients(value, property) {
        // Check if value is already present in newlyAdded array
        let isAlreadyAdded = false;

        if (property && value[property] && value[property].length > 0) {
            isAlreadyAdded = this.state.newlyAdded.some(item => item[property] === value[property]);
        }

        let newRecipients;

        if (isAlreadyAdded) {
            newRecipients = this.state.newlyAdded.map(item => {
                if (item[property] === value[property]) {
                    // Update the specified property to null while keeping other properties intact
                    return { ...item, [property]: null };
                } else {
                    return item;
                }
            }).filter(item => item.email !== null || item.recipient !== null);
        } else {
            // If the property is not already added, add the new value
            newRecipients = [...this.state.newlyAdded, value];
        }

        // Update the state with the newRecipients array
        this.setState({ newlyAdded: newRecipients });
    }

    addToCurrentForwards(forward, newRecipient) {
        var email = forward.email;
        var phone = forward.recipient;
        var nickname = (forward.nickname ? forward.nickname : null);
        var addToContacts = forward.addToContacts === true || forward.addToContacts === undefined ? true : null;

        const found = this.props.all_forwards.some(item =>
            (item.email === forward.email || (item.email === null && forward.email === undefined || forward?.email?.length < 1)) &&
            (item.recipient === forward.recipient || (item.recipient === null && forward.recipient === undefined || forward?.recipient?.length < 1)) &&
            item.nickname === forward.nickname
        );

        // handle newly added contacts
        if (newRecipient) {
            this.handleNewRecipients(forward, email ? "email" : "recipient");
            this.toggleSelected(forward)
        }

        if (phone && phone.length > 0) {
            if(!found){
                this.props.dispatch(addForwardContact({nickname: nickname, email: null, recipient: phone, addToContacts: addToContacts}));
                this.clearInputs();
            } else {
                this.props.dispatch(removeForwardContact({nickname: nickname, email: null, recipient: phone, addToContacts: addToContacts}))
            }
        }

        if (email && email.length > 0) {
            // console.log("inside email if, found: ", found);
            if(!found){
                this.props.dispatch(addForwardContact({nickname: nickname, email: email, recipient: null, addToContacts: addToContacts}));

                // console.log("--props-- ", this.props);
                this.clearInputs();
            } else {
                this.props.dispatch(removeForwardContact({nickname: nickname, email: email, recipient: null, addToContacts: addToContacts}))
            }
        }
    }

    clearInputs() {
        this.setState({
            email: '',
            recipient: '',
            nickname: '',
            custom_text: ''
        })
    }

    removeFromForwards(forward) {
        // console.log(forward)
        if (forward.email) {
            this.props.dispatch(removeForwardContact({nickname: forward.nickname, email: forward.email}))
        } else {
            this.props.dispatch(removeForwardContact({nickname: forward.nickname, recipient: forward.recipient}))
        }
        this.toggleSelected(forward)
    }

    // generate already saved contacts
    generateForwards() {
        var allforwards = [];

        if (this.props.existingRecipients) {
            Object.values(this.props.existingRecipients).forEach(array => {
                if (array.id) {
                    allforwards = allforwards.concat(array);
                }
            });
        }

        if (!this.props.emailOnly && this.props?.feedback_contacts?.length > 0) {
            this.props.feedback_contacts.map( function(forward,index) {
                if(forward.nickname) {
                    var jsx = <div key={index} onClick={this.addToCurrentForwards.bind(this, forward)} className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons forward-buttons"><i className="fas fa-user-plus mr-1 d-none d-sm-inline-block"></i> <span className="d-inline-block d-sm-none">+</span><span className='nn'>{forward.nickname + ": "}</span><span className='pn'>{forward.recipient}</span></div>
                } else {
                    var jsx = <div key={index} onClick={this.addToCurrentForwards.bind(this, forward)} className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons forward-buttons"><i className="fas fa-user-plus mr-1 d-none d-sm-inline-block"></i> <span className="d-inline-block d-sm-none">+</span><span className='pn'>{forward.recipient}</span></div>;
                }
                allforwards.push(jsx);
            }.bind(this));
        } else if (this.props.business_forwards?.length > 0) {
            this.props.business_forwards.map( function(forward,index) {
                if(forward.nickname) {
                    var jsx = <div key={index} onClick={this.addToCurrentForwards.bind(this, forward)} className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons forward-buttons"><i className="fas fa-user-plus mr-1 d-none d-sm-inline-block"></i> <span className="d-inline-block d-sm-none">+</span><span className='nn'>{forward.nickname + ": "}</span><span className='pn'>{forward.recipient}</span></div>
                } else {
                    var jsx = <div key={index} onClick={this.addToCurrentForwards.bind(this, forward)} className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons forward-buttons"><i className="fas fa-user-plus mr-1 d-none d-sm-inline-block"></i> <span className="d-inline-block d-sm-none">+</span><span className='pn'>{forward.recipient}</span></div>;
                }
                allforwards.push(jsx);
            }.bind(this));
        } else if (this.props.emailOnly && this.props?.feedback_contacts?.length > 0) {
            // add contacts
            this.props.feedback_contacts.map( function(forward,index) {
                if(forward.name) {
                    var jsx = <div
                        key={index}
                        onClick={this.addToCurrentForwards.bind(this, forward)}
                        className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons forward-buttons">
                        <i className="fas fa-user-plus mr-1 d-none d-sm-inline-block"></i>
                        <span className="d-inline-block d-sm-none">+</span>
                        <span className='nn'>{forward.name + ": "}</span>
                        <span className='pn'>{forward.email}</span>
                    </div>
                }
                allforwards.push(jsx);
            }.bind(this));

            // add employees
            this.props.feedback_employees.map( function(forward,index) {
                if(forward.name) {
                    var jsx = <div
                        key={index}
                        onClick={this.addToCurrentForwards.bind(this, forward)}
                        className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons forward-buttons">
                        <i className="fas fa-user-plus mr-1 d-none d-sm-inline-block"></i>
                        <span className="d-inline-block d-sm-none">+</span>
                        <span className='nn'>{forward.name + ": "}</span>
                        <span className='pn'>{forward.email}</span>
                    </div>
                }
                allforwards.push(jsx);
            }.bind(this));
        }

        // console.log("generate fwrds");

        this.setState({
            all_forwards: allforwards,
        })
        return allforwards;
    }

    validateEmail = (email) => {
        // Regular expression for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Check if the email matches the regex pattern
        const isValidEmail = emailRegex.test(email);

        // Return the validation result
        return isValidEmail;
    };

    handleKeyDown(e, prop) {
        if (prop === "recipient") {
            // Get the current value of the input field
            const currentValue = e.target.value;

            // Remove any non-digit characters from the input
            const newValue = currentValue.replace(/\D/g, '');

            // Update the state with the new value
            // formatted
            this.setState({
                [prop]: formatPhone(newValue)
            });
        }

        if (prop === "email") {
            this.setState({
                [prop]: e.target.value
            });
        }
    }

    handleAddToContactsCheckbox(forward) {
        const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        const businessId = this.props.feedback?.business?.business_id || this.props.businessId;
        let url;
        let postData;
        if (this.props.emailOnly) {
            url = '/business/' + businessId + '/report/add_bcc_table';
            postData = {
                weekly_report_cb: true,
                monthly_report_cb: true,
                function: true,
                type: "reports",
                _token: token,
                email: forward.email,
                name: forward.nickname
            };
        } else {
            url = '/business/' + businessId + '/forward-contacts/create';
            postData = {
                _token: token,
                phone: forward.phone || null,
                email: forward.email,
                nickname: forward.nickname
            }
        }

        axios.post(url, postData,
            {"X-CSRF-TOKEN": token}
        )
        .then((response) => {

            // save to AI Summary Recipients
            if (this.props.emailOnly) {
                this.handleAiRecipientAdd(response.data.id, response.data.name, response.data.email, 'contact');
            } else {
                // update the saved contacts list
                this.setState(prevState => ({
                    sortedContacts: [...prevState.sortedContacts, {
                        id: response.data.id,
                        nickname: response.data.nickname,
                        email: response.data.email,
                        recipient: response.data.phone
                    }]
                }));

                // update the newlyAdded list
                this.setState(prevState => ({
                    newlyAdded: prevState.newlyAdded.filter(item => item.id !== forward.id)
                }));
            }
        })
        .catch(error => {
            console.log(error?.response?.data);
        })
    }

    handleNickname(event){
        this.setState({
            nickname: event.target.value
        });
    }

    // edit not set details
    handleEditField(inputValue, type, id, savedData, nickname) {
        let newPhoneValue;
        if (type === "phone") {
            newPhoneValue = inputValue.replace(/\D/g, '');
        }

        let editedContact = {
            "id": id,
            "nickname": nickname,
            "email": type === "email" ? inputValue : savedData,
            "phone": type === "email" ? savedData : newPhoneValue
        };

        if (inputValue.length > 0) {
            // Update the new data to prevState
            this.setState(prevState => ({
                idsEdited: [...prevState.idsEdited.filter(item => item.id !== editedContact.id), editedContact]
            }));
        } else {
            // Filter out the current entry and remove id based on id
            this.setState(prevState => ({
                idsEdited: prevState.idsEdited.filter(item => item.id !== editedContact.id)
            }));
        }
    }

    saveEditedContact(event, id) {
        // validate email
        const button = event.target;
        const inputId = button.getAttribute('aria-controls');
        const input = document.getElementById(inputId);
        const selectedObj = this.state.idsEdited.find(item => item.id === id);

        if (inputId && input.type === "email") {
            input.reportValidity();
        }

        if (input.type === "email" && (!selectedObj.email || this.validateEmail(this.state.email))) {
            return;
        }

        const contactId = selectedObj.id;
        const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        const businessId = this.props.feedback?.business?.business_id || this.props.businessId;

        let url = '/business/' + businessId + '/forward-contacts/' + contactId + '/edit';

        axios.post(url, {
            _token: token,
            phone: selectedObj.phone,
            email: selectedObj.email,
            nickname: selectedObj.nickname
        },
            {"X-CSRF-TOKEN": token}
        )
          .then((response) => {
            // update the saved contacts list
            this.setState({ sortedContacts: this.addContactAndSort(this.state.sortedContacts, {
                    id: response.data.id,
                    nickname: response.data.nickname,
                    email: response.data.email,
                    recipient: response.data.phone
                })
            })

            // remove the entry from state
            this.setState(prevState => ({
                idsEdited: Array.isArray(prevState.idsEdited) ? prevState.idsEdited.filter(item => item.id !== selectedObj.id) : []
            }));

            // clear error state if any
            this.setState({
                errorMessages: [{
                    id: "",
                    messages: []
                }]
            });
        })
        .catch(error => {
            console.log(error?.response);
            if (error?.response?.data) {

                const keys = Object.keys(error?.response?.data.errors);
                const firstKey = keys[0];
                // Use the first key to access its corresponding value - not knowing what's coming
                const firstValue = error?.response?.data.errors[firstKey];

                this.setState({
                    errorMessages: [{
                        id: contactId,
                        messages: firstValue
                    }]
                });

            }
        })
    }

    componentDidMount() {
        this.generateForwards();
        // Sort the feedback_contacts array by nickname, with empty nicknames appearing first
        this.setState({ sortedContacts: this.addContactAndSort(this.props.feedback_contacts) });

        if (this.props.emailOnly) {
            // Sort the feedback_contacts array by nickname, with empty nicknames appearing first
            this.setState({
                sortedContacts: this.addContactAndSort(this.props.feedback_contacts).map(contact => ({
                    ...contact,
                    source: 'contact'
                }))
            });

            this.setState((prevState) => ({
                sortedContacts: [
                    ...prevState.sortedContacts,
                    ...this.addContactAndSort(this.props.feedback_employees).map(contact => ({
                        ...contact,
                        source: 'employee'
                    })),
                ],
            }));
        } else {
            // Sort the feedback_contacts array by nickname, with empty nicknames appearing first
            this.setState({ sortedContacts: this.addContactAndSort(this.props.feedback_contacts) });
        }
    }

    // listen for this.state.newlyAdded and this.props.feedback_contacts
    componentDidUpdate(prevProps, prevState) {
        // AI summary
        if (prevProps?.existingRecipients !== this.props?.existingRecipients) {
            this.setState({ aiSummaryRecipients: this.props.existingRecipients });
        }

        if (prevState.newlyAdded !== this.state.newlyAdded) {
            // Scroll to bottom when newlyAdded state changes
            const scrollList = this.contactsScrollListRef.current;
            if (scrollList) {
                const lastChild = scrollList.lastElementChild;
                if (lastChild) {
                    lastChild.scrollIntoView({ behavior: "smooth", block: "end" });
                }
            }
        }

        // reset states
        if (!jQuery('.modal').is(':visible')) {
            // clear inputs if left filled
            if (prevState.nickname.length > 0 || prevState.email.length > 0 || prevState.recipient.length > 0) {
                this.clearInputs();
            }

            // clear newlyAddedState if left unsaved
            if (prevState.newlyAdded.length > 0) {
                this.setState({ newlyAdded: [] });
            }

            // clear selected values after closing
            if (prevState.selectedValues.length > 0) {
                this.setState({ selectedValues: [] });
                this.props.dispatch(resetAllForwards({}));
            }

            // clear edited but not saved
            if (prevState.idsEdited.length > 1) {
                this.setState({
                    idsEdited: [
                        {
                            id: "",
                            nickname: "",
                            email: "",
                            phone: ""
                        }
                    ]
                });
            }
        }
    }

    onTextChange(event) {
        this.props.handleTextInput(event);
        if (this.props.custom_text.length > event.target.value.length) {
            jQuery("#email_forward_textarea").css("height", "0px");
        }
        jQuery("#email_forward_textarea").css("height", Math.max(Math.min(document.getElementById("email_forward_textarea").scrollHeight, 170), 50) + "px");
    }

    watchTutorialVideo(event) {
        event.preventDefault();
        const video = `
        <div class="d-flex w-100 h-100 attachment-modal">
            <iframe src="https://player.mediadelivery.net/embed/708979/0b8e4fa8-24a3-4f1b-b559-96447e2b0f65?autoplay=false&loop=false&muted=false&preload=true&responsive=true" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="How to get mail links to open in Gmail"></iframe>
            <span class="close close-attachment cursor-pointer text-white">x</span>
        </div>
        `;
        jQuery('body').append(video);
    }

    // add to contact list and sort
    addContactAndSort(contacts, newContact = { id: null, nickname: null }) {
        // Filter out the old entry with the same ID from the contacts array
        const updatedContacts = contacts.filter(contact => contact.id !== newContact.id);

        // Add the new entry to the updated contacts array
        updatedContacts.push(newContact);

        // Sort the updated contacts array
        const sortedContacts = updatedContacts.sort((a, b) => {
            const nicknameA = a.nickname ? a.nickname.toLowerCase() : '';
            const nicknameB = b.nickname ? b.nickname.toLowerCase() : '';

            if (!nicknameA && nicknameB) {
                return -1;
            }

            if (nicknameA && !nicknameB) {
                return 1;
            }

            if (nicknameA < nicknameB) {
                return -1;
            }

            if (nicknameA > nicknameB) {
                return 1;
            }

            return 0;
        });

        return sortedContacts;
    }

    // AI Summary Recipients functions
    handleAiRecipientAdd(recipientId, recipientNickname, recipientEmail, source) {
        let url = '/business/' + this.props.businessId + '/ai-reports/add-' + source +'-recipient/' + recipientId;

        // console.log("handleAiRecipientAdd: ", recipientId, recipientNickname, recipientEmail, source);

        axios.post(url, {},
        )
            .then((response) => {
                // update the saved contacts list
                // console.log("success!")
                this.addToCurrentForwards({nickname: recipientNickname, email: recipientEmail});
                this.toggleSelected({nickname: recipientNickname, email: recipientEmail})

                // add to the current state
                const { aiSummaryRecipients } = this.state;

                // Check if recipient with the same ID already exists
                const alreadyExists = aiSummaryRecipients.some(
                    (recipient) => recipient.id === recipientId
                );

                if (alreadyExists) return; // Skip adding if ID is already in the array

                this.setState((prevState) => ({
                    aiSummaryRecipients: [...prevState.aiSummaryRecipients, {
                        id: recipientId,
                        name: recipientNickname,
                        email: recipientEmail
                    }]
                }));
            })
            .catch(error => {
                console.log(error?.response?.data);
            })
    }

    handleDeleteAiRecipient(recipientId, recipientNickname, recipientEmail) {
        // console.log(recipientId);

        let url = '/business/' + this.props.businessId + '/ai-reports/remove-recipient/' + recipientId;

        axios.delete(url, {},
        )
            .then((response) => {
                // update the saved contacts list
                // console.log("success!");
                this.removeFromForwards({nickname: recipientNickname, email: recipientEmail});
                this.setState((prevState) => ({
                    aiSummaryRecipients: prevState.aiSummaryRecipients.filter(
                        (recipient) => recipient.id !== recipientId
                    )
                }));
            })
            .catch(error => {
                console.log(error?.response?.data);
            })
    }

	render () {
        if (!this.props.feedback && this.props.modal !== 'renderEmailForwardSummary') {
            return <></>;
        }

		return (
            <div className="simple-sms-field forward-feedback-wrapper">
                <div className="row">
                    <div className="col-sm-12 mb-3">
                        <h5 className="mb-2">{ this.props.emailOnly ? __('Select From Contacts and Employees') : __('Select From Contacts (gathered from Forward Recipients section)') }:</h5>
                        <div className='contacts-scroll-list' ref={this.contactsScrollListRef}>
                            {Array.isArray(this.state.sortedContacts) && this.state.sortedContacts.map((value,index) => {
                                if (value.nickname || value.name) {
                                    return (
                                        <div
                                            key={index}
                                            data-id={value.id}
                                            data-source={value.source}
                                            className="btn btn-md mt-1 pl-0 pr-0 forward-item"
                                        >
                                            <div className={`${this.props.emailOnly ? 'col-4' : 'col-3'} d-flex justify-content-start pl-0`}>
                                                <i className="far fa-user mr-2 d-none d-sm-inline-block"></i>
                                                <span className='forward-name'>{value.nickname || value.name}:</span>
                                            </div>

                                            <div className={`${this.props.emailOnly ? 'col-6' : 'col-4'} d-flex justify-content-start`}>
                                            {value.email
                                                    ? <span className='forward-email'>{value.email}</span>
                                                    :
                                                        <span className='forward-email forward-email--notset'>
                                                            <input
                                                                type="email"
                                                                id={"editinputemail" + index}
                                                                className="form-control pl-0 forward-email forward-email--edit"
                                                                placeholder="Email not set"
                                                                aria-label="Email"
                                                                onChange={(event) => this.handleEditField(event.target.value, "email", value.id, value.recipient, value.nickname || value.name)}
                                                            />
                                                            {this.state.idsEdited.some(item => item.id === value.id) &&
                                                                <button onClick={(event) => this.saveEditedContact(event, value.id)} aria-controls={"editinputemail" + index}>
                                                                    <i className="far fa-check-circle"></i>
                                                                </button>
                                                            }
                                                        </span>
                                                }
                                            </div>

                                            {!this.props.emailOnly &&
                                                <div className='col-3 d-flex justify-content-start'>
                                                    {value.recipient
                                                        ? <span className='forward-phone'>{formatPhone(value.recipient)}</span>
                                                        :
                                                            <span className='forward-phone forward-phone--notset'>
                                                                <input
                                                                    type="tel"
                                                                    id={"editinputphone" + index}
                                                                    className="form-control pl-0 forward-phone forward-phone--edit"
                                                                    placeholder="Phone not set"
                                                                    aria-label="Phone"
                                                                    // check if the array has an obj with item.id matching and set that value here
                                                                    value={this.state.idsEdited.some(item => item.id === value.id) ? formatPhone(this.state.idsEdited.find(item => item.id === value.id).phone) : ""}
                                                                    onChange={(event) => {this.handleEditField(event.target.value, "phone", value.id, value.email, value.nickname || value.name)}}
                                                                />
                                                                {this.state.idsEdited.some(item => item.id === value.id) &&
                                                                    <button onClick={(event) => this.saveEditedContact(event, value.id)} aria-controls={"editinputphone" + index}>
                                                                        <i className="far fa-check-circle"></i>
                                                                    </button>
                                                                }
                                                            </span>
                                                    }
                                                </div>
                                            }

                                            {/* toggle */}
                                            <div className='col-2 d-flex justify-content-end'>
                                                <span className='forward-toggle'>
                                                    <span
                                                        data-singleitem={this.props.emailOnly}
                                                        onClick={() =>
                                                        {
                                                            if (this.props.emailOnly && value.email) {
                                                                this.handleAiRecipientAdd(value.id, value.nickname || value.name, value.email, value.source);
                                                                return;
                                                            }

                                                            if (!this.props.emailOnly && value.email) {
                                                                // console.log("inside if", value);
                                                                this.addToCurrentForwards({nickname: value.nickname, email: value.email});
                                                                this.toggleSelected({nickname: value.nickname, email: value.email})
                                                            }
                                                        }}
                                                        data-selected={!this.props.emailOnly ? this.state.selectedValues.some(obj => obj?.email === value.email) : this.state.aiSummaryRecipients.some(obj => obj?.email === value.email)}
                                                        data-disabled={!value.email}
                                                    >{this.props.emailOnly ? __("Select") : __("Email")}</span>

                                                    {!this.props.emailOnly &&
                                                        <span onClick={() =>
                                                            {
                                                                if (value.recipient) {
                                                                    this.addToCurrentForwards({nickname: value.nickname, recipient: value.recipient})
                                                                    this.toggleSelected({nickname: value.nickname, recipient: value.recipient})
                                                                }
                                                            }}
                                                            data-selected={this.state.selectedValues.some((obj) =>
                                                                obj?.recipient === value.recipient && value.recipient
                                                            )}
                                                            data-disabled={!value.recipient}
                                                        >{__("Text")}</span>
                                                    }
                                                </span>
                                            </div>

                                            {/* errors */ }
                                            {this.state.errorMessages.some(item => item.id === value.id) &&
                                                    this.state.errorMessages.map((item, index) => {
                                                        return (
                                                            <span className='forward-item--error' key={index}>{item.messages}</span>
                                                        )
                                                })
                                            }
                                        </div>
                                    )
                                }
                            })}

                            {/* newly added contacts */}
                            {this.state?.newlyAdded.map((value,index) => (
                                <div key={index} className={`btn btn-md mt-1 pl-0 pr-0 forward-item forward-item--blue forward-item--new`}>
                                    <div className='d-flex flex-row w-100'>
                                        <div className={`${this.props.emailOnly ? 'col-4' : 'col-3'} d-flex justify-content-start align-items-center pl-0`}>
                                            <i className="far fa-user mr-2 d-none d-sm-inline-block"></i>
                                            <span className='forward-name'>{value.nickname || value.name}:</span>
                                        </div>

                                        <div className={`${this.props.emailOnly ? 'col-6' : 'col-4'} d-flex justify-content-start`}>
                                            {value.email
                                                ? <span className='forward-email'>{value.email}</span>
                                                : <span className='forward-email forward-email--notset'>{__("email not set")}</span>
                                            }
                                        </div>

                                        {!this.props.emailOnly &&
                                            <div className='col-3 d-flex justify-content-start'>
                                                {value.recipient
                                                    ? <span className='forward-phone'>{value.recipient}</span>
                                                    : <span className='forward-phone forward-phone--notset'>{__("phone number not set")}</span>
                                                }
                                            </div>
                                        }

                                        {/* toggle */}
                                        <div className='col-2 d-flex justify-content-end'>
                                            <span className='forward-toggle'>
                                                <span onClick={() =>
                                                    {
                                                        if (value.email) {
                                                            this.addToCurrentForwards({nickname: value.nickname, email: value.email});
                                                            this.toggleSelected({nickname: value.nickname, email: value.email})
                                                        }
                                                    }}
                                                    data-singleitem={this.props.emailOnly}
                                                    data-selected={this.props.all_forwards.some(obj => obj?.email === value.email)}
                                                    data-disabled={!value.email}
                                                >{this.props.emailOnly ? __("Select") : __("Email")}</span>

                                                {!this.props.emailOnly &&
                                                    <span onClick={() =>
                                                        {
                                                            if (value.recipient) {
                                                                this.addToCurrentForwards({nickname: value.nickname, recipient: value.recipient});
                                                                this.toggleSelected({nickname: value.nickname, recipient: value.recipient})
                                                            }
                                                        }}
                                                        data-selected={this.props.all_forwards.some(obj => obj?.recipient === value.recipient)}
                                                        data-disabled={!value.recipient}
                                                    >{__("Text")}</span>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    {!this.props.emailOnly &&
                                        <div className="new-contacts-wrapper">
                                            <button
                                                className='btn btn-md btn-outline-primary'
                                                onClick={() => {
                                                    this.handleAddToContactsCheckbox({id: value.id, nickname: value.nickname, email: value.email, phone: value.recipient});
                                                }}>
                                                {__("Save to Contacts for later use")}
                                            </button>
                                        </div>
                                    }
                                </div>

                            ))}
                        </div>

                        <div className="forward-item new-item">
                            {/* Mobile-only heading for the add-new-recipient group (RTF-4044) */}
                            <span className="d-block d-sm-none w-100 mb-1 forward-new-label"><b>{__('Add New Recipient')}</b></span>
                            <div className={`${this.props.emailOnly ? 'col-4' : 'col-3'} d-flex justify-content-start align-items-center pl-0`}>
                                <i className="far fa-user mr-2 d-none d-sm-inline-block"></i>
                                <input
                                    type="text"
                                    onChange={this.handleNickname}
                                    value={this.state.nickname}
                                    className="form-control pl-0 forward-nickname"
                                    placeholder="New Recipient"
                                    aria-label="New Recipient"
                                />
                            </div>

                            <div className={`${this.props.emailOnly ? 'col-6' : 'col-4'} d-flex justify-content-start`}>
                                <input
                                    type="email"
                                    onChange={(e) => this.handleKeyDown(e, "email")}
                                    value={this.state.email}
                                    className="form-control pl-0 forward-email"
                                    id="forward_email"
                                    placeholder="Email"
                                    aria-label="Email"
                                />
                            </div>

                            {!this.props.emailOnly &&
                                <div className='col-3 d-flex justify-content-start'>
                                    <input
                                        type="tel"
                                        onChange={(e) => this.handleKeyDown(e, "recipient")}
                                        value={this.state.recipient}
                                        className="form-control pl-1 forward-number"
                                        id="forward_phone"
                                        placeholder="Phone"
                                        aria-label="Phone"
                                        required
                                    />
                                </div>
                            }

                            <div className='col-2 d-flex justify-content-end'>
                                <button
                                    className="btn btn-md btn-primary btn-add-item"
                                    onClick={() => {
                                        if (this.props.emailOnly && this.state.email && this.validateEmail(this.state.email)) {
                                            this.handleAddToContactsCheckbox({
                                                nickname: this.state.nickname,
                                                email: this.state.email
                                            })
                                        }

                                        if (this.state.email && this.validateEmail(this.state.email)) {
                                            this.addToCurrentForwards({
                                                nickname: this.state.nickname,
                                                email: this.state.email,
                                                recipient: this.state.recipient,
                                            }, true);
                                        } else {
                                            document.querySelector("#forward_email").reportValidity()
                                        }

                                        if (!this.state.email) {
                                            this.addToCurrentForwards({
                                                nickname: this.state.nickname,
                                                email: this.state.email,
                                                recipient: this.state.recipient,
                                            }, true);
                                        }
                                    }}
                                    type="button"
                                    disabled={!this.state.email && !this.state.recipient}
                                >
                                    <i className="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Currently Forwarding */}
                    <div className="col-sm-12">
                        <h5 className="mb-1">{ __('Currently Forwarding To') }:</h5>
                    </div>

                    <div className="col-sm-12 forward-recipients">
                        {/* No contacts saved */}
                        {this.props?.all_forwards?.length === 0 && this.props?.existingRecipients?.length === 0 &&
                            <span className="text-muted forward-info">None</span>
                        }

                        {/* List contacts */}
                        {this.state.aiSummaryRecipients.length === 0 && this.props.all_forwards && this.props.all_forwards.map((value,index) => {
                            return (
                                <div key={index} className="recipient-item selected-phone-no" onClick={() => this.removeFromForwards({nickname: value.nickname, recipient: value.recipient, email: value.email})}>
                                    <span className="text-capitalize">{value.nickname ? value.nickname : null}&nbsp;</span>
                                    {value.email && !value.recipient && !this.props.emailOnly &&
                                        __("(Email)")
                                    }

                                    {!value.email && value.recipient &&
                                        __("(Text)")
                                    }
                                    <i className="fas fa-times ml-1 mr-1"></i>
                                </div>);
                        })}

                        {/* List contacts for AI Summary */}
                        {this.state?.aiSummaryRecipients && this.state?.aiSummaryRecipients.map((value, index) => {
                            return (
                                <div key={index} className="recipient-item selected-phone-no" onClick={() => {
                                    this.handleDeleteAiRecipient(value.id, value.name, value.email);
                                }}>
                                    <span className="text-capitalize">{value.name ? value.name : null}&nbsp;</span>
                                    {value.email && !value.recipient && !this.props.emailOnly &&
                                        __("(Email)")
                                    }

                                    {!value.email && value.recipient &&
                                        __("(Text)")
                                    }
                                    <i className="fas fa-times ml-1 mr-1"></i>
                                </div>);
                        })}
                    </div>

                    {/* Alert: no contacts selected */}
                    <div className="col-sm-12 d-none d-sm-block mt-3">
                        <p className="alert alert-sm alert-warning modal-warning mt-1">{ __('Please make sure to add contacts.') }.</p>
                    </div>


                    {/* Info Text */}
                    {!this.props.emailOnly &&
                        <div className="col-sm-12 mt-2">
                            <p className="forward-info">{ __('You can choose to add a message to the forwarded Feedback. You may also choose to hide the personal information of the Feedbacker') }.</p>
                        </div>
                    }

                    {/* Message Textarea */}
                    {!this.props.emailOnly &&
                        <div className="col-sm-12 mt-2">
                            <div className="forward-message feedback-form-control mb-0">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><i className="fas fa-comment"></i></span>
                                </div>
                                <textarea id="email_forward_textarea"
                                    style={{ resize: "none", minHeight: "50px" }}
                                    rows={1}
                                    onChange={this.onTextChange.bind(this)}
                                    className="pl-0"
                                    value={this.props.custom_text} placeholder={ __('Message')}
                                    aria-label="Message"
                                />
                            </div>
                        </div>
                    }

                    {/* Hide User Info */}
                    {!this.props.emailOnly &&
                        <div className="col-sm-12 mt-3 mb-2">
                            <div className="d-flex feedback-form-control mb-0">
                                <label className="d-flex align-items-center mb-0">
                                    <input type="checkbox" className="hide-userinfo ml-0 mr-2" id="hide-userinfo" />
                                    <span className="d-inline-block forward-info"> { __('Hide User Info In Forwarded Feedback') }</span>
                                </label>
                            </div>
                        </div>
                    }

                    {/* Gmail Info */}
                    {!this.props.emailOnly &&
                        <div className='col-sm-12 mt-2'>
                            <p className="forward-info mb-0">{__('Using Gmail as your email client?')}</p>
                            <a href="#" onClick={this.watchTutorialVideo.bind()}>{__('Watch video on updating your browser so forward opens Gmail.')}</a>
                        </div>
                    }
                </div>

                {!this.props.emailOnly &&
                    <>
                        <input type="hidden" id="user_name" value={(this.props.feedback.user.firstname + " " +this.props.feedback.user.lastname?this.props.feedback.user.firstname + " " +this.props.feedback.user.lastname:"Anonymous")}/>
                        <input type="hidden" id="user_id" value={this.props.feedback.user.user_id}/>
                        <input type="hidden" id="feedback_id" value={this.props.feedback.feedback_id}/>
                        <input type="hidden" id="business_id" value={this.props.feedback.business.business_id}/>
                        <input type="hidden" id="company_name" value={this.props.feedback.business.name}/>
                    </>
                }
            </div>
        );
	}
}

function mapStateToProps(state) {
    // console.log("mapstate: ", state);
    if (state.modal.modal_body === 'renderEmailForwardSummary') {
        return {
            feedback: state.feedback_detail,
            all_forwards: state.all_forwards,
            current_email_forwards: state.current_email_forwards,
            feedback_contacts: state.contacts,
            feedback_employees: state.employees,
            modal: state.modal.modal_body,
            existingRecipients: state.existingRecipients
        }
    } else {
        return {
            feedback: state.feedback_detail,
            all_forwards: state.all_forwards,
            current_email_forwards: state.current_email_forwards,
            feedback_contacts: state.feedback_detail.forward_contacts
        }
    }
}

export default connect(mapStateToProps)(ForwardFeedback)
